module.exports = __webpack_public_path__ + "media/images/home/procedures@2x-364e0985d9c2d1ee182da4b7fe31b70b.png";